import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initSentry } from './lib/sentry';
import './index.css';
import { App } from './app';

// Initialize Sentry before rendering (no-op when VITE_SENTRY_DSN is not set)
initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
